const firebaseConfig = {
  apiKey: "AIzaSyB_K9SWJHh0n1QAQhz3FRJ0ZKv-o5-Xtm0",
  authDomain: "crypto-hunter-82200.firebaseapp.com",
  projectId: "crypto-hunter-82200",
  storageBucket: "crypto-hunter-82200.appspot.com",
  messagingSenderId: "689056661459",
  appId: "1:689056661459:web:c8fd1dcb050c28fcfeb926",
};

export default firebaseConfig;
